import React, { useEffect, useContext, useState } from 'react'
import { ErpClientContext } from '../../services/erp'
import {
  Form,
  Select,
  Input,
  message,
  DatePicker,
  Space,
  Button,
  Table,
} from 'antd'
import { sleep } from '@guillotinaweb/react-gmi'

const initial = {
  company: '',
  comision_fija: 0,
  codigo_factura: '',
  fecha_factura: '',
}

function formatCurrency(value) {
  return Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
  }).format(value)
}

export default function ImportCommissionsCollectionsV2() {
  const erpService = useContext(ErpClientContext)
  const [companies, setCompanies] = useState([])
  const [companieSelected, setCompanieSelected] = useState(null)
  const [state, setState] = useState(initial)
  const [inputFile, setInputFile] = useState(null)
  const [loading, setLoading] = useState(false)
  const [columnsTable, setColumnsTable] = useState(null)
  const [optionsColumns, setOptionsColumns] = useState([])
  const [dataTable, setDataTable] = useState([])
  const [lecturaFichero, setLecturaFichero] = useState(false)
  const [comisionPedido, setComisionPedido] = useState(null)
  const [comisionExtra, setComisionExtra] = useState(null)
  const [data, setData] = useState(null)

  const { Option } = Select

  useEffect(() => {
    init()
  }, [])
  async function init() {
    const resCompanies = await erpService.getAllPaymentCommissionCompanies()
    setCompanies(resCompanies)

    const res = await erpService.getImportedInvoiceV2('commissions')

    const filterColumn = () =>
      companies.map((val) => ({
        text: val.label,
        value: val.label,
      }))

    const columnsAlignRight = [
      'total_value_of_matched_costs',
      'total_value_of_not_matched_costs',
    ]

    setColumnsTable(
      Object.keys(res[0]).map((column) => ({
        title: column.replace(/_/g, ' ').toUpperCase(),
        dataIndex: column,
        columnKey: column,
        sorter:
          column === 'invoice_date'
            ? (a, b) => new Date(a.invoice_date) - new Date(b.invoice_date)
            : null,
        filters: column === 'id_company' ? filterColumn() : null,
        onFilter: (value, record) =>
          record.id_pasarela_company.startsWith(value),
        filterSearch: true,
        align: columnsAlignRight.includes(column) ? 'right' : null,
      }))
    )
    const dataColumnsImportedInvoices = res.map((dataRes) => {
      return {
        invoice_date: dataRes.invoice_date,
        invoice_number: dataRes.invoice_number,
        name_company: dataRes.name_company,
        total_value_of_matched_costs: formatCurrency(
          dataRes.total_value_of_matched_costs
        ),
        total_value_of_not_matched_costs: formatCurrency(
          dataRes.total_value_of_not_matched_costs
        ),
      }
    })
    setDataTable(dataColumnsImportedInvoices)
  }

  function handleFileChange(e) {
    if (e.target.files.length) {
      setInputFile(e.target.files[0])
    }
  }

  async function uploadFile() {
    setLoading(true)
    if (
      state.company === '' ||
      state.codigo_factura === '' ||
      state.fecha_factura === '' ||
      !inputFile
    ) {
      message.error('Revisa los campos!')
      await sleep(2000)
      window.location.reload(false)
    }
    const formData = new FormData()
    formData.append('file', inputFile)

    const queryString = new URLSearchParams({
      company: state.company,
    }).toString()
    const url = `/orders/@upload_invoice_v2?${queryString}`

    const res = await erpService.fetch(url, {
      method: 'POST',
      body: formData,
      params: JSON.stringify({
        company: state.company,
      }),
    })

    console.log(res)

    const response = await res.json()
    if (res.status === 200) {
      setColumnsTable(
        Object.keys(response['data'][0]).map((column) => ({
          title: column,
          dataIndex: column,
          key: column,
          width: '120px',
        }))
      )

      // setOptionsColumns(
      // Object.keys(response['data'][0]).map((column) => ({
      //     value: column,
      //     label: column,
      // }))
      // )

      const resData = response.data.map((responseValue) => ({
        line: responseValue.line,
        pedido: responseValue.pedido,
        comision: formatCurrency(responseValue.comision),
        descripcion: responseValue.descripcion,
      }))

      setData(response.data)
      setDataTable(resData)
      setLecturaFichero(true)
      setLoading(false)
      setComisionPedido(response.comision_pedido)
      setComisionExtra(response.comision_extra)
    } else {
      setLoading(false)
      message.error(`Ops algo salio mal: ${response}`)
    }

    // const response = await res.json()

    // setColumnsTable(
    //     Object.keys(response['data'][0]).map((column) => ({
    //       title: column,
    //       dataIndex: column,
    //       key: column,
    //       width: '120px',
    //     }))
    //   )

    // // setOptionsColumns(
    // // Object.keys(response['data'][0]).map((column) => ({
    // //     value: column,
    // //     label: column,
    // // }))
    // // )

    // const resData = response.data.map((responseValue) => ({
    //     line: responseValue.line,
    //     pedido: responseValue.pedido,
    //     comision: formatCurrency(responseValue.comision),
    //     descripcion: responseValue.descripcion
    //   }))

    // setData(response.data)
    // setDataTable(resData)
    // setLecturaFichero(true)
    // setLoading(false)
    // setComisionPedido(response.comision_pedido)
    // setComisionExtra(response.comision_extra)
  }

  async function confirmData() {
    setLoading(true)

    const res = await erpService.fetch(
      '/orders/@confirm_commissions_collections',
      {
        method: 'POST',
        body: JSON.stringify({
          company: state.company,
          data: data,
          fecha_factura: state.fecha_factura,
          codigo_factura: state.codigo_factura,
          comision_fija: state.comision_fija,
        }),
      }
    )

    if (res.status === 200) {
      message.success('Datos registrados correctamente!')
      await sleep(2000)
      window.location.reload(false)
    } else {
      const messageError = await res.json()
      message.error(`Oops! ${JSON.stringify(messageError)}`)
    }

    setLoading(false)
  }

  return (
    <div
      className="container"
      style={{
        backgroundColor: '#fff',
        padding: '30px',
      }}
    >
      <div style={{ 'margin-top': '10px' }}>
        <div className="field">
          <label className="label">Select payment gateway:</label>
          <Form onFinish={!lecturaFichero ? uploadFile : confirmData}>
            {!lecturaFichero ? (
              <div>
                <Select
                  showSearch
                  defaultValue="Select payment gateway"
                  key="id_company"
                  onChange={(value) => {
                    setState({
                      ...state,
                      company: value,
                    })
                  }}
                  style={{
                    width: 250,
                  }}
                >
                  {companies.map((company) => (
                    <Option value={company.id_company}>{company.nombre}</Option>
                  ))}
                </Select>
                <div className="field" style={{ 'margin-top': '10px' }}>
                  <label className="label">Enter invoice id:</label>
                  <Input
                    className="is-size-6"
                    id="codigo_factura"
                    onChange={(e) => {
                      setState({
                        ...state,
                        codigo_factura: e.target.value,
                      })
                    }}
                    style={{
                      width: 250,
                    }}
                  />
                </div>
                {state.company === 'pyco' ? (
                  <div className="field" style={{ 'margin-top': '10px' }}>
                    <label className="label">Fixed commission:</label>
                    <Input
                      className="is-size-6"
                      id="comision_fija"
                      onChange={(e) => {
                        setState({
                          ...state,
                          comision_fija: e.target.value,
                        })
                      }}
                      style={{
                        width: 250,
                      }}
                    />
                  </div>
                ) : null}
                <div className="field" style={{ 'margin-top': '10px' }}>
                  <label
                    className="label"
                    htmlFor="csvInput"
                    style={{ display: 'block' }}
                  >
                    Import File
                  </label>
                  <Input
                    onChange={handleFileChange}
                    id="csvInput"
                    name="file"
                    type="File"
                    style={{
                      width: 500,
                    }}
                  />
                </div>
                <div className="field">
                  <label className="label">Select invoice date:</label>
                  <DatePicker
                    format={'DD/MM/YYYY'}
                    onChange={(date) => {
                      setState({
                        ...state,
                        fecha_factura: `${date._d.getFullYear()}-${
                          date._d.getMonth() + 1
                        }-${date._d.getDate()}`,
                      })
                    }}
                  />
                </div>
              </div>
            ) : (
              <div>
                <div className="field">
                  <label className="label">
                    Comisiones cobradas: {comisionPedido} €
                  </label>
                </div>
                <div className="field">
                  <label className="label">
                    Comisiones reembolsos: {comisionExtra} €
                  </label>
                </div>
              </div>
            )}
            <div style={{ 'margin-top': '10px' }}>
              <Form.Item>
                <Space direction="horizontal" size="large">
                  <Button type="primary" htmlType="submit">
                    {!lecturaFichero ? 'Get data' : 'Confirm'}
                  </Button>
                  <Button
                    type="dashed"
                    htmlType="button"
                    onClick={() => window.location.reload(false)}
                  >
                    Reset
                  </Button>
                </Space>
              </Form.Item>
            </div>
            <div style={{ 'margin-top': '10px' }}>
              <Table
                columns={columnsTable}
                dataSource={dataTable}
                bordered
                sticky
                scroll={{
                  x: true,
                  y: true,
                }}
                size="small"
                pagination={false}
              />
            </div>
          </Form>
        </div>
      </div>
    </div>
  )
}
